import { AdType } from './adbutler/utils/types';
import { FreestarPlacementId } from './freestar/utils/types';
import { RenderAd } from './render-ad';

interface RenderFloatingAdProps {
	className?: string;
	height: number;
	ipAddress?: string;
	pageId: number;
	place: number;
	placementId?: FreestarPlacementId;
	zoneId: AdType;
	width: number;
	// Required: forwarded straight to RenderAd, where an omitted value means "not prod".
	isProd: boolean;
	showFromWidth?: number;
}

export const RenderFloatingAd = ({
	className,
	height,
	ipAddress,
	pageId,
	place,
	placementId,
	width,
	zoneId,
	isProd,
	showFromWidth = 0
}: RenderFloatingAdProps) => {
	return (
		<div className="sticky top-4 w-full">
			<div className="w-full overflow-hidden">
				<RenderAd
					className={className}
					height={height}
					ipAddress={ipAddress}
					pageId={pageId}
					place={place}
					width={width}
					placementId={placementId}
					zoneId={zoneId}
					isProd={isProd}
					showFromWidth={showFromWidth}
				/>
			</div>
		</div>
	);
};
